import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td, Badge, Text } from "@chakra-ui/react";

const TalentPoolTable = ({ pools = [] }) => {
  if (!pools.length) {
    return <Text color="gray.500">Create first pool.</Text>;
  }

  return (
    <Table size="sm">
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Description</Th>
          <Th>Candidates</Th>
          <Th>Status</Th>
        </Tr>
      </Thead>
      <Tbody>
        {pools.map((pool) => (
          <Tr key={pool._id}>
            <Td>{pool.name}</Td>
            <Td>{pool.description || "-"}</Td>
            <Td>{pool.candidateIds?.length || 0}</Td>
            <Td>
              <Badge colorScheme={pool.isArchived ? "gray" : "green"}>
                {pool.isArchived ? "Archived" : "Active"}
              </Badge>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default TalentPoolTable;
